import { Component, inject, input, Input, OnInit, signal } from '@angular/core'
import { ReactiveFormsModule, FormGroup } from '@angular/forms'
import { NgSelectModule } from '@ng-select/ng-select'
import { SmartQuoteTemplateService } from 'src/app/core/services/smartquote/smartquote-template.service'
import { CardComponent } from 'src/app/shared/components/card/card.component'
import { ConfirmationDialogService } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.service'
import { InputTextareaComponent } from 'src/app/shared/components/form-elements/input-textarea/input-textarea.component'
import { InputComponent } from 'src/app/shared/components/form-elements/input/input.component'
import { LabelComponent } from 'src/app/shared/components/form-elements/label/label.component'
import { PostcodeLookupComponent } from 'src/app/shared/components/form-elements/postcode-lookup/postcode-lookup.component'
import { PostcodeAddress } from 'src/app/shared/interfaces/postcode-lookup/postcode-address.interface'
import { SmartQuoteTemplate } from 'src/app/shared/interfaces/smartquote-template/smartquote-template.interface'

@Component({
    selector: 'sf-smartquote-details',
    imports: [
        ReactiveFormsModule,
        NgSelectModule,
        CardComponent,
        LabelComponent,
        InputComponent,
        InputTextareaComponent,
        PostcodeLookupComponent,
    ],
    templateUrl: './smartquote-details.component.html',
    styleUrl: './smartquote-details.component.scss',
})
export class SmartquoteDetailsComponent implements OnInit {
    #confirmationService = inject(ConfirmationDialogService)

    @Input() form!: FormGroup
    smartQuoteTemplates = input<SmartQuoteTemplate[]>([])

    existingWorkAddress = signal(null)

    selectAddress(address: PostcodeAddress) {
        this.form.patchValue({
            addressLine1: address.line1,
            addressLine2: address.line2,
            town: address.townOrCity,
            county: address.county,
            postcode: address.postcode,
        })
    }

    ngOnInit(): void {
        this.form.valueChanges.subscribe(({ workAddress }) => this.existingWorkAddress.set(workAddress))
    }

    onJobTypeChange(jobType: SmartQuoteTemplate) {
        this.#confirmationService
            .confirm(
                'Are you sure?',
                'Are you sure you want to load this template? This will overwrite the job description field.'
            )
            .then((confirmed) => {
                if (confirmed) {
                    this.form.patchValue({
                        notes: jobType.description,
                    })
                }
            })
    }
}
